<template>
    <div class="intervenants container-md py-5 text-center">
        <h1 class="text-400">Intervenants</h1>

        <div class="row w-100 mt-2 justify-content-center">
            <div class="col-12 col-sm-6 col-lg-4" v-for="item in items" v-bind:key="item.fullName">
                <IntervenantItem :intervenant="item" />
            </div>
        </div>
    </div>
</template>

<script>
import IntervenantItem from "@/components/IntervenantItem.vue";

export default {
    components: {
        IntervenantItem,
    },
    data() {
        return {
            items: [
                { fullName: "Agnès VERDIER-MOLINIÉ", jobTitle: "Lobbyiste & essayiste", photoPath: "verdier-molinie.jpg" },
                { fullName: "Sandrine SARROCHE", jobTitle: "Humoriste & chroniqueuse", photoPath: "sarroche.jpg" },
                { fullName: "Raphaël AUPHAN", jobTitle: "CEO de Qwant", photoPath: "auphan.jpg" },
                { fullName: "Sophie ROPARS", jobTitle: "Directrice Marketing DS Automobiles France", photoPath: "ropars.jpg" },
                { fullName: "Charles PEPIN", jobTitle: "Philosophe de l'optimisme", photoPath: "pepin.jpg" },
            ],
        };
    },
};
</script>
